module.exports = __webpack_public_path__ + "media/images/play-dcbc1906386eb1361153e8a2c16c702d.svg";